
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'PatternSelector',

  props: {
    testPatterns: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    excludePatterns: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    vcsUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      testPatternsModel: '',
      excludePatternsModel: ''
    }
  },

  watch: {
    testPatterns: {
      handler() {
        this.testPatternsModel = this.testPatterns.join('\n')
      }
    },
    excludePatterns: {
      handler() {
        this.excludePatternsModel = this.excludePatterns.join('\n')
      }
    },
    testPatternsModel() {
      this.updatePatterns()
    },
    excludePatternsModel() {
      this.updatePatterns()
    }
  },

  mounted() {
    this.testPatternsModel = this.testPatterns.join('\n')
    this.excludePatternsModel = this.excludePatterns.join('\n')
  },

  methods: {
    updatePatterns() {
      this.$emit('updatePatterns', {
        test_patterns: this.testPatternsModel.split('\n'),
        exclude_patterns: this.excludePatternsModel.split('\n')
      })
    }
  }
})
